import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { SimpleClient } from 'shared/models/Client'

export const reducer = createSlice({
  name: 'clientStore',
  initialState: {
    currentId: null as string | null,
    clients: [] as SimpleClient[],
    isSettingClient: false,
  },
  reducers: {
    setActiveClientIdStarted: (state) => {
      state.isSettingClient = true
    },
    setActiveClientId: (state, action: PayloadAction<string | null>) => {
      state.currentId = action.payload
      state.isSettingClient = false
    },
    setUserClients: (state, action: PayloadAction<SimpleClient[]>) => {
      state.clients = action.payload
    },
  },
})

export default reducer
